import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { path } from 'ramda';

import { isAncor, isKA } from 'utils/version';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { openModalCompany } from 'actions/modalActions.js';

@connect(null, { openModalCompany })
export default class ProjectGeneral extends Component {
    static propTypes = {
        project: PropTypes.object.isRequired,
        openModalCompany: PropTypes.func.isRequired,
    };

    render() {
        const { project, project: { categorypart, svodkapart, company, scenname }, openModalCompany } = this.props;
        const status = `${categorypart ? categorypart + '.' : ''} ${svodkapart || ''}`;

        return (
            <div>
                <DefinitionHeader translate="common.general" iconType="info-outline" />
                <div className="panel-view">
                    <DefinitionField translate="project.type" text={project.projectType} />
                    <DefinitionField translate="project.position" text={path(['posname', '0', 'text'], project)} />
                    { (isAncor() || isKA()) && (
                        <DefinitionField translate="project.company">
                            <a onClick={() => openModalCompany(company)}>
                                {path(['company', 'text'], project)}
                            </a>
                        </DefinitionField>
                    )}
                    <DefinitionField translate="project.quantityPosition" text={project.quantity} />
                    <DefinitionField translate="project.restPosition" text={project.vacancies} />
                    <DefinitionField translate="project.city" text={project.town} />
                    { !isAncor() && (
                        <DefinitionField translate="project.department">
                            { project.departmentPosition || <Translate content='common.headquarters' /> }
                        </DefinitionField>
                    )}
                    <DefinitionField translate="project.budget" text={project.budget} />
                    <DefinitionField translate="project.reason" text={project.reason} />
                    <DefinitionField translate="project.status_project" text={status} />
                    <DefinitionField translate="project.inworksinse" text={project.inworkdate} />
                    <DefinitionField translate="project.duration" text={project.duration} />
                    <DefinitionField translate="project.deadline" text={project.closebefore} />
                    <DefinitionField translate="project.conditions" text={project.conditions} />
                    { scenname && <DefinitionField translate="project.scenario" text={project.scenname} /> }
                </div>
            </div>
        );
    }
}
